import React from "react";
import {Field, Formik} from "formik";
import {TextField} from "formik-mui";
import {capitalize} from "@mui/material";
import {useTranslation} from "react-i18next";

type FilterProps = {
    startDatum?: string;
    endeDatum?: string;
    setCustomField: (field: any, value: any) => void;
};

export default function StartEndFilter({startDatum, endeDatum, setCustomField}: FilterProps) {
    const {t} = useTranslation("entsorgungsdokumentation");
    return (
        <Formik
            initialValues={{
                startDatum: "",
                endDatum: "",
            }}
            onSubmit={() => {
            }}
        >
            <>
                <Field
                    size={"small"}
                    sx={{ml: 2}}
                    component={TextField}
                    name="startDatum"
                    label={capitalize(t("start-date"))}
                    type={"date"}
                    InputLabelProps={{shrink: true}}
                    onChange={(val: any) => setCustomField("startDate", val.target.value)}
                    value={startDatum}
                    InputProps={{
                        inputProps: {
                            max: endeDatum,
                        },
                    }}
                />
                <Field
                    sx={{ml: 2}}
                    size={"small"}
                    component={TextField}
                    name="endDatum"
                    label={capitalize(t("end-date"))}
                    type={"date"}
                    InputLabelProps={{shrink: true}}
                    onChange={(val: any) => setCustomField("endDate", val.target.value)}
                    value={endeDatum}
                    inputProps={{
                        min: startDatum,
                    }}
                />
            </>
        </Formik>
    );
}
